import React from "react";

import BundleSections from "./jsons/bundleSections.json";
import BundleActivities from "./jsons/local_db_activities.json";
import BundleActivitiesByCategory from "./jsons/local_db_activities_by_cat.json";
import BundleActivitiesByTag from "./jsons/local_db_activities_by_tag.json";
import BundleCategories from "./jsons/local_db_categories.json";
import BundleActivitiesByTagAndCategory from "./jsons/bundleActivitiesByTagAndCategory.json";
import BundleBadges from "./jsons/bundleBadges.json";
import BundleNews from "./jsons/local_db_news.json" //Ajout

export const LocalDBContext = React.createContext({
    sections: BundleSections,
    categories: BundleCategories,
    activities: BundleActivities,
    activitiesByCategory: BundleActivitiesByCategory,
    activitiesByTagAndCategory: BundleActivitiesByTagAndCategory,
    activitiesByTag: BundleActivitiesByTag,
    badges:BundleBadges,
    news : BundleNews, //Ajout
});

export const LocalDBConsumer = LocalDBContext.Consumer;

export class LocalDBProvider extends React.Component {

    state = {
        sections: BundleSections,
        categories: BundleCategories,
        activities: BundleActivities,
        activitiesByCategory: BundleActivitiesByCategory,
        activitiesByTag: BundleActivitiesByTag,
        activitiesByTagAndCategory: BundleActivitiesByTagAndCategory,
        badges:BundleBadges,
        news : BundleNews //Ajout
    }

    render() {
        const { sections, categories, activities, activitiesByCategory, activitiesByTag, activitiesByTagAndCategory, badges, news } = this.state;
        return (
            <LocalDBContext.Provider
                value={{
                    sections,
                    categories,
                    activities,
                    activitiesByCategory,
                    activitiesByTag,
                    activitiesByTagAndCategory,
                    badges,
                    news

                }}>
                {this.props.children}
            </LocalDBContext.Provider>
        )
    }

}

